// src/pages/ImmersiveTechnologies.js
import React from 'react';
import { NavLink } from 'react-router-dom';

function ImmersiveTechnologies() {
  return (
    <>

      {/* Breadcrumb Section */}
      <div
        className="optech-breadcrumb"
        style={{ backgroundImage: 'url(/assets/images/breadcrumb/breadcrumb.png)' }}
      >
        <div className="container">
          <h1 className="post__title">Immersive Technologies</h1>
          <nav className="breadcrumbs">
            <ul>
              <li><NavLink to="/services">AI Service</NavLink></li>
              <li aria-current="page">Immersive Technologies</li>
            </ul>
          </nav>
          <p className="text-white pt-5">
            Immersive technologies—Augmented Reality (AR), Virtual Reality (VR), and Mixed Reality (MR)—offer transformative approaches to interaction, training, and engagement. R A Inc helps organizations adopt these emerging solutions, merging technical know-how with strategic guidance.
          </p>
        </div>
      </div>

      {/* Service Section */}
      <div className="section optech-section-padding">
        <div className="container">
          <div className="row">
            {/* Left Content Area */}
            <div className="col-lg-8">
              <div className="optech-service-details-wrap">
                <img
                  data-aos="fade-up"
                  data-aos-duration="800"
                  src="/assets/images/service/immersive-tech.jpg"
                  alt="Immersive Technologies"
                />

                {/* Overview Section */}
                <div className="optech-service-details-item">
                  <h3>Overview</h3>
                  <p>
                    AR integrates digital components into the physical environment, VR generates entirely simulated worlds, and MR combines both elements to offer interactive, dynamic scenarios. These immersive frameworks open up avenues for immersive product demos, advanced skill training, and interactive sales experiences. As adoption grows across sectors like real estate, education, and entertainment, the need for well-planned, user-centric experiences remains paramount.
                  </p>
                </div>

                {/* Key Services */}
                <div className="optech-service-details-item">
                  <h3>Key Services</h3>
                  <ul className="optech-icon-list">
                    <li><i className="ri-check-line" /><strong> AR & VR Apps:</strong> Creation of applications for training, virtual tours, or specialized customer interactions.</li>
                    <li><i className="ri-check-line" /><strong> Superimposition Software:</strong> Tools for overlaying virtual visuals onto the real-world environment.</li>
                    <li><i className="ri-check-line" /><strong> Simulation Systems:</strong> Mock environments that replicate real-life processes for safe, cost-effective practice.</li>
                    <li><i className="ri-check-line" /><strong> 360-Degree VR Content:</strong> Immersive media that envelops users in panoramic views.</li>
                  </ul>
                </div>

                {/* Use Case Table */}
                <div className="optech-service-details-item">
                  <h3>Potential Use Cases</h3>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sector</th>
                        <th>Immersive Application</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Real Estate</td>
                        <td>In-depth virtual property walkthroughs for remote buyers</td>
                      </tr>
                      <tr>
                        <td>Education</td>
                        <td>Interactive lab simulations for complex subjects</td>
                      </tr>
                      <tr>
                        <td>Retail</td>
                        <td>Augmented reality product try-ons or demonstrations</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Highlights */}
                <div className="optech-service-details-item">
                  <h3>Highlights</h3>
                  <ul className="list-unstyled">
                    <li><i className="ri-check-line" />Boosted engagement through hands-on, experiential learning and exploration.</li>
                    <li><i className="ri-check-line" />Potential for collaboration across geographies, enabling remote teamwork and shared simulations.</li>
                    <li><i className="ri-check-line" />Decreased operational expenses by reducing the need for physical prototypes or in-person demos.</li>
                  </ul>
                </div>

                {/* Conclusion */}
                <div className="optech-service-details-item">
                  <h3>Conclusion</h3>
                  <p>
                    Immersive technologies elevate how users perceive and engage with digital content, turning ordinary experiences into compelling journeys. By blending AR, VR, or MR with carefully designed user flows, R A Inc assists businesses in delivering memorable solutions that can keep pace with contemporary customer expectations.
                  </p>
                </div>
              </div>
            </div>

            {/* Sidebar Section */}
            <div className="col-lg-4">
              <div className="optech-service-sidebar">
                <div className="optech-service-menu">
                         <ul>
                           <li>
                             <NavLink to="/data-annotation-services">
                               Data Annotation Services <i className="ri-arrow-right-up-line" />
                             </NavLink>
                           </li>
                           <li>
                             <NavLink to="/chat-prompt-optimization">
                               Chat Prompt Optimization <i className="ri-arrow-right-up-line" />
                             </NavLink>
                           </li>
                           <li>
                             <NavLink to="/image-processing-and-labeling">
                               Image Processing And Labeling <i className="ri-arrow-right-up-line" />
                             </NavLink>
                           </li>
                           <li>
                             <NavLink to="/chatbot-training-and-testing">
                               Chatbot Training & Testing <i className="ri-arrow-right-up-line" />
                             </NavLink>
                           </li>
                           <li>
                             <NavLink to="/image-localilzation-editing-and-retouching">
                               Image Localization, Editing & Retouching <i className="ri-arrow-right-up-line" />
                             </NavLink>
                           </li>
                           <li>
                             <NavLink to="/immersive-technologies">
                               Immersive Technologies <i className="ri-arrow-right-up-line" />
                             </NavLink>
                           </li>
                         </ul>
                </div>
                <div
                  className="optech-service-contact"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  style={{ backgroundImage: 'url(/assets/images/service/bg.png)' }}
                >
                  <div className="optech-service-contact-icon">
                    <img src="/assets/images/service/icon.svg" alt="" />
                  </div>
                  <h3>Need Immersive Tech Solutions?</h3>
                  <p>Partner with us to design interactive, cutting-edge experiences through AR, VR, and MR technologies tailored for your market.</p>
                  <NavLink className="optech-default-btn" data-text="Get in Touch" to="/contact-us">
                    <span className="btn-wraper">Get in Touch</span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div
        className="section bg-cover optech-section-padding"
        style={{ backgroundImage: 'url(/assets/images/cta/cta-bg2.png)' }}
      >
        <div className="container">
          <div className="optech-cta-wrap">
            <div className="optech-cta-content center">
              <h2>Let's Translate Your Vision Into Every Language</h2>
              <p>Whether you're expanding your business internationally or need multilingual content for local markets, we provide solutions tailored to your goals, audience, and tone.</p>
              <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
                <NavLink className="optech-default-btn" data-text="Let’s Start a Project" to="/contact-us">
                  <span className="btn-wraper">Let’s Start a Project</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default ImmersiveTechnologies;